import React from 'react';
import './PreUniversity.css';

const PreUniversity = () => {
    return (
        <div className="programme-details">
            <div className="programme-title">
            <h2>Pre - University</h2>
            </div>
            <div className="programme-descripttion">
            <h3>What is a foundation course?</h3>
            <p>A foundation course is a programme that will prepare you for an undergraduate degree at university. They are specifically designed for international students who want to study abroad, such as in Europe or the USA. Studying a foundation course will help you attain the correct level of qualifications and skills to pursue a degree at university - it will also help students who require additional English language support. A foundation year is usually available as a three-term programme which is made up of academic modules and specific modules related to your chosen subject.</p>
            <h3>What is a foundation year equivalent to?</h3>
            <p>A foundation year bridges the gap if you don’t have the right qualifications to go straight on to an undergraduate degree programme. It provides a broad introduction to subjects of your choice and helps you gain valuable academic, study and English language skills. A foundation year differs from a foundation degree. A foundation degree is a qualification equivalent to two years of a three-year undergraduate degree, while a foundation year gives you the academic and English skills to progress on to an undergraduate degree.</p>
            <h3>Our Foundation Programmes : </h3>
            <ul>
                <li>Foundation In Science .</li>
                <li>Foundation In Couputer Science .</li>
                <li>Foundation In Cloud Computing .</li>
                <li>Foundation In Business .</li>
                <li>Foundation In Management</li>
                <li>Foundation In Humanities .</li>
                <li>Foundation In Internation Law .</li>
            </ul>
            <h3>Duration : </h3>
            <ul>
                <li>Full Course 1Year .</li>
                <li>6 Month (each semester) .</li>
            </ul>
            <h3>What qualifications do I need to be accepted to a foundation programme?</h3>
            <ul>
                <li>Successful completion of 12 years of basic education anywhere in the world .</li>
                <li>Basic language proficiency depending on the requirements in the country</li>
                <li>Proof of studying certain subjects in your high school syllabus relevant for the foundation programme .</li>
            </ul>
            </div>
        </div>
    );
};

export default PreUniversity;